<template>
  <div
    v-if="clo.type == 'HLINE'"
    :style="`transform: rotate(${clo.hline_angle}deg);`"
  >
    <div style="position:relative;">
      <hr
        :style="
          `display: flex;justify-content: space-between;position:relative;align-items:center;background: ${clo.hline_color};height: ${clo.hline_height}px`
        "
        class="my-1"
      />
      <div
        :style="
          `display: flex;justify-content: space-between;position: absolute;top:-50%;width: 100%;align-items: center;flex-directions:row;`
        "
      >
        <div
          v-if="clo.hline_left_end == 'p'"
          :style="
            `width: ${clo.hline_height * 2}px;height: ${clo.hline_height *
              2}px;background: ${
              clo.hline_color
            };border-radius: 100%;margin-left:-1px;`
          "
        ></div>
        <div
          v-if="clo.hline_left_end == 'a'"
          :style="
            `width: ${clo.hline_height * 2}px;height: ${clo.hline_height *
              2}px;margin: 0px 0px 0px ${clo.hline_height -
              3}px;transform: rotate(45deg);box-shadow: -${clo.hline_height -
              1}px ${clo.hline_height - 1}px 0 ${clo.hline_color};`
          "
        ></div>
        <div
          v-if="clo.hline_right_end == 'p'"
          :style="
            `width: ${clo.hline_height * 2}px;height: ${clo.hline_height *
              2}px;background: ${
              clo.hline_color
            };border-radius: 100%;margin-right:-1px;`
          "
        ></div>
        <div
          v-if="clo.hline_right_end == 'a'"
          :style="
            `width: ${clo.hline_height * 2}px;height: ${clo.hline_height *
              2}px;margin: -${clo.hline_height - 6}px ${clo.hline_height -
              2}px 0px 0px;transform: rotate(-135deg);box-shadow: -${clo.hline_height -
              1}px ${clo.hline_height - 1}px 0 ${clo.hline_color};`
          "
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "show-line",
  props: {
    clo: {
      type: Object,
    },
  },
};
</script>
